export default "/images/vendor/flag-icons/flags/4x3/tv.svg?fd2caae1fd2cb51b675a3189221b978c";